import { createAsyncThunk } from '@reduxjs/toolkit';
import store, { waitForCustomerLogin } from '../../../store/store';
import { ActionStatus } from '../../../common/constants/action-status';
import { getCustomerToken } from '../../customer/customer';
import { StoreState } from '../../../store/store.interface';
import { getInstructorSampleOrdersStatus } from '../store/my-account.selector';
import { getInstructorSampleOrdersApiCall } from '../api/my-account-orders.api';
import { handleApiError, ApiError } from '../../../common/utils/api-utils';

export const fetchInstructorSampleOrders = createAsyncThunk(
  'myAccount/fetchInstructorSampleOrders',
  async ({ forceUpdate = false }: { forceUpdate?: boolean } = {}, thunkAPI) => {
    try {
      const userProfileResponse = store.getState().userProfileState.userProfileResponse;
      if (userProfileResponse?.status !== ActionStatus.succeeded || !userProfileResponse.data) {
        return [];
      }

      await waitForCustomerLogin();
      return await getInstructorSampleOrdersApiCall(getCustomerToken(thunkAPI.getState() as StoreState));
    } catch (error) {
      if (error instanceof ApiError) {
        handleApiError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  },
  {
    condition: ({ forceUpdate = false }, { getState }) => {
      return (
        forceUpdate ||
        ![ActionStatus.succeeded, ActionStatus.loading].includes(
          getInstructorSampleOrdersStatus(getState() as StoreState)
        )
      );
    },
  }
);
